//入口文件，加载公共组件
//导入vue构造函数
import Vue from "vue";
//导入根组件App.vue
import App from "./App.vue";
//导入路由文件
import router from "./router";
import store from "./store";
import VueCookie from "vue-cookie";
import ElementUI from "element-ui";
//import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/theme/index.css'
import '@/styles/index.scss' // global css
import httpRequest from "./utils/httpRequest";
import api from "@/api/index";

Vue.use(VueCookie)
Vue.use(ElementUI);
// 设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.config.productionTip = false;

// 全局挂载
Vue.prototype.$http = httpRequest; // ajax请求方法
Vue.prototype.$api = api;
document.title = "四川威尔检测网上受理";
new Vue({
    router,
    //根组件注入store
    store,
    render: (h) => h(App)
}).$mount('#app');